var I18nManager={allowRTL(){},forceRTL(){},getConstants:()=>({isRTL:!1})};export default I18nManager;